import { client } from './client';
import { endpoints } from './endpoints';

export async function updateAgentLastSeen(): Promise<void> {
  const response = await client.put(endpoints.UPDATE_LAST_SEEN);

  return response.data;
}
